import { ReactComponent as ChevronDownImg } from 'assets/images/icons/inputs/chevron-down.svg';
import { ReactComponent as ChevronUpImg } from 'assets/images/icons/inputs/chevron-up.svg';
import { ReactComponent as ChevronDownIconComponent } from 'images/v2/icons/svg/fill/svg/chevron-down.svg';
import { ReactComponent as ChevronUpIconComponent } from 'images/v2/icons/svg/fill/svg/chevron-up.svg';
import { ReactComponent as CopyIconComponent } from 'images/v2/icons/svg/fill/svg/copy.svg';
import { ReactComponent as CrossIconComponent } from 'images/v2/icons/svg/fill/svg/cross.svg';
import { ReactComponent as DownloadIconComponent } from 'images/v2/icons/svg/fill/svg/download.svg';
import { components } from 'react-select';
import styled, { css } from 'styled-components';

export const ChevronDownIcon = styled(ChevronDownImg)`
  color: ${(props) => props.theme.colors.primaryBlack};
  &:hover {
    color: ${(props) => props.theme.colors.primaryOrange};
    cursor: pointer;
  }
`;

export const ChevronUpIcon = styled(ChevronUpImg)`
  color: ${(props) => props.theme.colors.primaryBlack};
  &:hover {
    color: ${(props) => props.theme.colors.primaryOrange};
    cursor: pointer;
  }
`;

export const StyledCrossIcon = styled(CrossIconComponent)`
  width: 16px;
  height: 16px;
  color: ${(props) => props.theme.colors.primaryBlack};
  cursor: pointer;
  &:hover {
    color: ${(props) => props.theme.colors.primaryOrange};
    cursor: pointer;
  }
  align-self: center;
`;

export const StyledChevronDownIcon = styled(ChevronDownIconComponent)`
  width: 18px;
  height: 18px;
  color: ${(props) => props.theme.colors.primaryBlack};
  &:hover {
    color: ${(props) => props.theme.colors.primaryOrange};
    cursor: pointer;
  }
`;

export const StyledChevronUpIcon = styled(ChevronUpIconComponent)`
  width: 18px;
  height: 18px;
  color: ${(props) => props.theme.colors.primaryBlack};
  &:hover {
    color: ${(props) => props.theme.colors.primaryOrange};
    cursor: pointer;
  }
`;

export const StyledDownloadIcon = styled(DownloadIconComponent)<{ $disabled?: boolean }>`
  width: 16px;
  height: 16px;

  ${(props) =>
    !props.$disabled
      ? css`
          color: ${props.theme.colors.primaryBlack};
          cursor: pointer;
          &:hover {
            color: ${props.theme.colors.primaryOrange};
          }
        `
      : css`
          color: ${props.theme.colors.elementsButtonDisabled};
        `}
`;

export const StyledCopyIcon = styled(CopyIconComponent)`
  width: 16px;
  height: 16px;
  color: ${(props) => props.theme.colors.primaryBlack};
  cursor: pointer;
  &:hover {
    color: ${(props) => props.theme.colors.primaryOrange};
  }
`;

export const ClearIndicator = (props: any) => (
  <components.ClearIndicator {...props}>
    <StyledCrossIcon />
  </components.ClearIndicator>
);

export const DropdownIndicator = (props: any) => {
  const { selectProps } = props;
  const isOpen = selectProps.menuIsOpen;

  return (
    <components.DropdownIndicator {...props}>
      {isOpen ? <StyledChevronUpIcon /> : <StyledChevronDownIcon />}
    </components.DropdownIndicator>
  );
};
